import axios from 'axios';
const headers = {
    'Content-Type': 'application/json',
    'x-api-key': PRICING_SERVICE_API_KEY,
};
export const getMarketRates = (marketId, limit, offset) => {
    const url = `${PRICING_SERVICE_HOST}/market/shipper/rate?marketId=${marketId}&per_page=${limit}&skip=${offset}`;
    const options = {
        url,
        method: 'get',
        headers,
    };
    return axios(options);
};
export const deleteMarketRate = (rateId) => {
    const url = `${PRICING_SERVICE_HOST}/market/shipper/rate/${rateId}`;
    const options = {
        url,
        method: 'delete',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': PRICING_SERVICE_API_KEY,
        },
    };
    return axios(options);
};
export const updateMarketShipperRate = (data = {}) => {
    const url = `${PRICING_SERVICE_HOST}/market/shipper/rate`;
    const options = {
        url,
        method: 'put',
        headers,
        data,
    };
    return axios(options);
};
const getMarketShipperRate = (query) => {
    const { shipperId, marketId } = query;
    const url = `${PRICING_SERVICE_HOST}/market/shipper/rate?shipperId=${shipperId}&marketId=${marketId}`;
    const options = {
        url,
        method: 'get',
        headers,
    };
    return axios(options);
};
export async function updateMarketShipperRateWrapper(data) {
    try {
        return await updateMarketShipperRate(data);
    }
    catch (e) {
        console.log('Error during updating MarketShipperRate: ', e.message);
        return { error: e };
    }
}
export async function getMarketShipperRateWrapper(query) {
    try {
        const res = await getMarketShipperRate(query);
        return res.data || [];
    }
    catch (e) {
        console.log('Error during getting MarketShipperRate: ', e.message);
        return [];
    }
}
